import { Alert } from "react-bootstrap";

export default function ErrorAlert({ msg, onClose }) {
  return (
    <Alert variant="danger" dismissible onClose={onClose}>
      {msg}
    </Alert>
  );
}
